// Shim de rétrocompatibilité — exporte le singleton ApiService.
// Les 35+ consommateurs de ce module continuent à fonctionner sans modification.
// TODO: Phase 2 — migrer les consommateurs vers l'import direct de ApiService ou le SocketContext.
import { ApiService } from '../services/socket/ApiService';

const api = new ApiService();

export default api;
